import { useRestContext } from 'components/form/RestInputContext';
import { RETURN_METHOD, RETURN_STATUS } from 'constants/ordersReturn';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { formatDateTime } from 'utils/formattedString';

export default function OrderSummary() {
  const { t } = useTranslation();
  const { record } = useRestContext();

  const getData = () =>
    useMemo(() => {
      const data = [
        {
          title: `${t('ordersReturn.summary.returnRequestNo')}:`,
          value: record?.returnNumber || '-',
        },
        {
          title: `${t('ordersReturn.summary.originalOrderNo')}:`,
          value: record?.orderNumber || '-',
        },
        {
          title: `${t('ordersReturn.channel')}:`,
          value: record?.order?.channelDisplay || '-',
        },
        {
          title: `${t('ordersReturn.summary.returnType')}:`,
          value: record?.returnType || '-',
        },
        {
          title: `${t('ordersReturn.summary.returnMethod')}:`,
          value: t(RETURN_METHOD[record?.returnMethod]?.text) || '-',
        },
        {
          title: `${t('ordersReturn.summary.paymentMethod')}:`,
          value:
            record?.refundPaymentMethod?.name ||
            record?.order?.paymentType ||
            '-',
        },
        // {
        //   title: `${t('ordersReturn.summary.whoPayShippingFee')}:`,
        //   value:
        //     t(WHO_PAY_SHIPPING_FEE[record?.whoPayShippingFee]?.text) || '-',
        // },
      ];
      switch (record?.status) {
        case RETURN_STATUS['AWAITING_APPROVAL'].value:
          data.splice(2, 0, {
            title: `${t('ordersReturn.createdTime')}:`,
            value: formatDateTime(record?.createdAt) || '-',
          });
          break;
        case RETURN_STATUS['APPROVED'].value:
          data.splice(2, 0, {
            title: `${t('ordersReturn.summary.approvedTime')}:`,
            value: formatDateTime(record?.approvedTime) || '-',
          });
          break;
        case RETURN_STATUS['FAILED_QC'].value:
          data.splice(2, 0, {
            title: `${t('ordersReturn.summary.failedQCTime')}:`,
            value: formatDateTime(record?.failedQCTime) || '-',
          });
          break;
        case RETURN_STATUS['PASS_QC'].value:
          data.splice(
            2,
            0,
            ...[
              // {
              //    title: `SOR:`,
              //    value: record?.sorId || '-'
              // },
              {
                title: `${t('ordersReturn.summary.passedQCTime')}:`,
                value: formatDateTime(record?.passQCTime) || '-',
              },
            ],
          );
          break;
        case RETURN_STATUS['COMPLETED'].value:
          data.splice(
            2,
            0,
            ...[
              {
                title: `SOR:`,
                value: record?.sorId || '-',
              },
              {
                title: `${t('ordersReturn.summary.completedTime')}:`,
                value: formatDateTime(record?.completedTime) || '-',
              },
            ],
          );
          break;
        case RETURN_STATUS['CANCELLED'].value:
          data.splice(2, 0, {
            title: `${t('ordersReturn.summary.cancelledTime')}:`,
            value: formatDateTime(record?.cancelledTime) || '-',
          });
          break;
        case RETURN_STATUS['WAITING_FOR_REFUND'].value:
          data.splice(
            2,
            0,
            ...[
              {
                title: `${t('ordersReturn.summary.sorCreatedTime')}:`,
                value: formatDateTime(record?.sorTime) || '-',
              },
              {
                title: `SOR:`,
                value: record?.sorId || '-',
              },
            ],
          );
          break;
        default:
          break;
      }
      return data;
    }, [record]);

  return (
    <div className="p-[10px] border-[1px] border-border-dark-gray bg-white">
      <div className="bg-bg-ghost-white p-[10px] flex gap-[6px]">
        {getData()?.map((item, index) => (
          <div
            key={`summary-${index.toString}`}
            className="text-text-primary flex-1"
          >
            {item.title}
            <div className="font-bold mt-[5px]">{item?.value}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
